var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPopupCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.93 37.23L39.9075 19.2525L36.3375 15.6825L21.93 30.09L14.6625 22.8225L11.0925 26.3925L21.93 37.23ZM25.5 51C21.9725 51 18.6575 50.3306 15.555 48.9919C12.4525 47.6531 9.75375 45.8363 7.45875 43.5412C5.16375 41.2463 3.34687 38.5475 2.00813 35.445C0.669375 32.3425 0 29.0275 0 25.5C0 21.9725 0.669375 18.6575 2.00813 15.555C3.34687 12.4525 5.16375 9.75375 7.45875 7.45875C9.75375 5.16375 12.4525 3.34687 15.555 2.00813C18.6575 0.669375 21.9725 0 25.5 0C29.0275 0 32.3425 0.669375 35.445 2.00813C38.5475 3.34687 41.2463 5.16375 43.5412 7.45875C45.8363 9.75375 47.6531 12.4525 48.9919 15.555C50.3306 18.6575 51 21.9725 51 25.5C51 29.0275 50.3306 32.3425 48.9919 35.445C47.6531 38.5475 45.8363 41.2463 43.5412 43.5412C41.2463 45.8363 38.5475 47.6531 35.445 48.9919C32.3425 50.3306 29.0275 51 25.5 51Z",
    fill: "#34A88D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPopupCheck);
export default __webpack_public_path__ + "static/media/popupCheck.58674981d519897ecdbeb06d7b3a0aaa.svg";
export { ForwardRef as ReactComponent };